import {
  ExportTemplate,
  type GetDealByIdQuery,
} from '@/lib/graphql/generated/graphql';

export enum ExportStatus {
  Completed = 'completed',
  Created = 'created',
  Error = 'error',
}

export const isExportSettled = (status: string) =>
  status === ExportStatus.Completed || status === ExportStatus.Error;

export interface ExportError {
  step: string;
  code?: string;
  operation?: string;
  documentTitle?: string;
  fileId?: string;
}

export type DealSelectionExportFromQuery = NonNullable<
  GetDealByIdQuery['deal']
>['selectionExports'][number];

export const latestValidationErrorsExport = (
  exports: readonly DealSelectionExportFromQuery[]
) =>
  exports
    .filter(
      (entry) =>
        entry.status === ExportStatus.Completed &&
        (entry.template === ExportTemplate.ValidationErrors ||
          entry.template === ExportTemplate.ValidationErrorsSource)
    )
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime() ||
        b.id.localeCompare(a.id)
    )[0];
